import { render, staticRenderFns } from "./AddAlert.vue?vue&type=template&id=7b8a7a9f&scoped=true"
import script from "./AddAlert.vue?vue&type=script&lang=js"
export * from "./AddAlert.vue?vue&type=script&lang=js"
import style0 from "./AddAlert.vue?vue&type=style&index=0&id=7b8a7a9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8a7a9f",
  null
  
)

export default component.exports